import { render } from "./open-new-investror-account.vue?vue&type=template&id=58841855"
import script from "./open-new-investror-account.vue?vue&type=script&lang=js"
export * from "./open-new-investror-account.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__